/**
 * Created by Abner Sui on 10/09/2020.
 * Description:
 *
 * ------ maintenance history ------
 * 10/15/2021 Simon Zhao added a form group for dynamic assignee validation.
 */

import { Subject } from 'rxjs';
import { TaskDefinition } from '../../../tamalelibs/models/workflow.model';
import { UntypedFormGroup } from '@angular/forms';
export class TaskDefinitionConfig {
    actionSubject$: Subject<any>;
    feedbackSubject$: Subject<any>;
    taskDefinition: TaskDefinition;
    configChanged = false;
    isImport = false;
}

export enum TaskDefinitionEventTypes {
    CANCEL = 'CANCEL',
    SAVE = 'SAVE',
    DELETE = 'DELETE',
    ERROR = 'ERROR',
    VERIFY = 'VERIFY',
}

export class TaskDefinitionNeedValidControl {
    name: boolean;
    assignee: boolean;
    stage: boolean;
    dynamicAssigneeFormGroup: UntypedFormGroup;
    constructor() {
        this.name = false;
        this.assignee = false;
        this.stage = false;
    }
}
